import { parseCityCountry } from '@/lib/cityCountry';
import { normalizeCountryToIso } from '@/lib/countries/countryLabels';
import { parseOptionalAge } from '@/lib/mapRegisteredParticipantToAzdanceApi';
import type { ParticipantGender } from '@/state/stores/registrationStore';

export { participantToUserProfile as registeredParticipantToUserProfile } from '@/state/stores/registrationStore';

export type ContactMessengerType = 'telegram' | 'whatsapp' | 'instagram' | '';

export type ProfileRegistrationFormData = {
  firstName: string;
  lastName: string;
  age: string;
  email: string;
  phone: string;
  country: string;
  city: string;
  gender: ParticipantGender;
  role: 'leader' | 'follower' | 'switch' | '';
  level: 'beginner' | 'intermediate' | 'advanced' | 'professional' | '';
  contactType: ContactMessengerType;
  contactValue: string;
};

export function emptyProfileRegistrationForm(): ProfileRegistrationFormData {
  return {
    firstName: '',
    lastName: '',
    age: '',
    email: '',
    phone: '',
    country: '',
    city: '',
    gender: '',
    role: '',
    level: '',
    contactType: '',
    contactValue: '',
  };
}

export type ParticipantFormSource = {
  firstName?: string;
  lastName?: string;
  age?: string | number;
  email?: string;
  phone?: string;
  location?: string;
  city?: string;
  country?: string;
  gender?: ParticipantGender;
  role?: 'leader' | 'follower' | 'switch' | '';
  level?: 'beginner' | 'intermediate' | 'advanced' | 'professional' | '';
  contactType?: 'telegram' | 'whatsapp' | 'instagram' | '';
  contactValue?: string;
  instagram?: string;
};

export function participantLikeToForm(p: ParticipantFormSource): ProfileRegistrationFormData {
  let city = (p.city ?? '').trim();
  let country = (p.country ?? '').trim();
  if (!city && !country && p.location) {
    const x = parseCityCountry(p.location);
    city = x.city;
    country = x.country;
  }
  const iso = normalizeCountryToIso(country);
  if (iso) country = iso;

  let contactType = (p.contactType ?? '') as ContactMessengerType;
  let contactValue = (p.contactValue ?? '').trim();

  if (!contactType && p.instagram?.trim()) {
    contactType = 'instagram';
    contactValue = p.instagram.replace(/^@/, '').trim();
  }

  return {
    firstName: p.firstName || '',
    lastName: p.lastName || '',
    age: p.age != null ? String(p.age) : '',
    email: p.email || '',
    phone: p.phone || '',
    country,
    city,
    gender: p.gender || '',
    role: p.role || '',
    level: p.level || '',
    contactType,
    contactValue,
  };
}

/** Поля для сохранения в currentUser / RegisteredParticipant (API: city + countryCode; без склейки location). */
export function formDataToProfilePatch(data: ProfileRegistrationFormData) {
  const city = data.city.trim();
  const country = data.country.trim();
  const contactValue = data.contactValue.trim();
  const instagram =
    data.contactType === 'instagram' ? contactValue.replace(/^@/, '') : '';

  return {
    firstName: data.firstName.trim(),
    lastName: data.lastName.trim(),
    age: parseOptionalAge(data.age),
    email: data.email.trim(),
    phone: data.phone.trim(),
    country,
    city,
    location: '',
    gender: data.gender,
    role: data.role,
    level: data.level,
    contactType: data.contactType,
    contactValue,
    instagram,
  };
}
